module.exports = __webpack_public_path__ + "img/footer-background-1600.2.c05dfac.jpg";